import React, { useEffect, useRef, useState } from "react";
import { FaLocationDot } from "react-icons/fa6";
import { HiPencil } from "react-icons/hi2";
import ApiService from "../../services/ApiService";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import AboutTab from "../../components/Profile/About";
import MyJob from "../../components/Profile/MyJob";
import Photos from "../../components/Profile/Photos";
import Videos from "../../components/Profile/Videos";
import EditProfile from "../../components/Profile/Edit-Profile";
import Image from "../../components/Image";
import { User } from "lucide-react";
import { useUser } from "../../context/UserContext";
import { useTranslation } from "react-i18next";

const Profile = () => {
  const [isEditing, setIsEditing] = useState(false);
  // const [profileData, setProfileData] = useState(null);
  const [skillsData, setSkillsData] = useState(null);
  const hasFetchedProfile = useRef(false);
  const [isLoading, setIsLoading] = useState(false);
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const location = useLocation();
    const { userType, profileData, fetchProfile, updateProfile } = useUser();

  const getQueryParam = (key) => {
    return new URLSearchParams(location.search).get(key);
  };

  const [activeTab, setActiveTab] = useState(
    getQueryParam("subTab") || "about"
  );

  useEffect(() => {
    const currentTab = getQueryParam("subTab");
    if (currentTab && currentTab !== activeTab) {
      setActiveTab(currentTab);
    }
  }, [location.search]);

  // useEffect(() => {
  //   // if (hasFetchedProfile.current) return;
  //   // hasFetchedProfile.current = true;
  //   fetchProfile();
  //   fetchSkillsData();
  // }, []);

  // const fetchProfile = async () => {
  //   try {
  //     setIsLoading(true);
  //     const response = await ApiService.request({
  //       method: "GET",
  //       url: `getProfile`,
  //     });
  //     const data = response.data;

  //     if (data.status) {
  //       setProfileData(data.data.talent);
  //     } else {
  //       toast.error(data.message);
  //     }
  //     setIsLoading(false);
  //   } catch (error) {
  //     setIsLoading(false);
  //     console.error("Error fetching profile:", error);
  //   }
  // };

  const fetchSkillsData = async () => {
    try {
      const response = await ApiService.request({
        method: "GET",
        url: `getSkills`,
      });
      const data = response.data;

      if (data.status) {
        setSkillsData(data.data.skills);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error("Error fetching skills data:", error);
    }
  };

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleBack = async () => {
    setIsEditing(false);
    await fetchProfile();
  };

// Returns true if data for a tab is incomplete
// Returns true if data for a tab is incomplete
const isTabIncomplete = (tabId) => {
  if (!profileData) return false;
  const t = profileData.talent;

  switch (tabId) {
    case "about":
      return (
        !t.first_name ||
        !t.last_name ||
        !t.email ||
        !t.phone ||
        !t.country ||
        !t.nationality ||
        // !t.address ||
        !t.about ||
        !t.year_experience ||
        !t.education ||
        !t.skill_id?._id ||
        !t.sub_skill_ids?.length ||
        !t.height ||
        !t.weight ||
        !t.languages?.length ||
        !t.picture ||
        !t.resume ||
        !t.social_accounts?.instagram ||
        !t.social_accounts?.tiktok 
        // !t.social_accounts?.twitter
      );
    case "jobs":
      return profileData.jobs_count === false;

    case "photos":
      return profileData.photos_count === false;

    case "videos":
      return profileData.videos_count === false;

    default:
      return false;
  }
};





  return (
    <div className="inter-font " style={{ minHeight: "100vh" }}>
      {isEditing ? (
        <EditProfile onBack={handleBack} />
      ) : (
        <div
  className="inter-font container ps-3 ps-md-5 py-4 bg-white rounded-4 shadow mt-4"
  style={{ maxWidth: "900px" }}
>
  <div className="inter-font row align-items-start">
    {/* Left: Profile + Tabs */}
    <div className="inter-font col-12 col-md-2 text-center mb-4 mb-md-0">
        <Image
          src={profileData?.talent.picture}
          className="inter-font rounded-circle"
          style={{ width: "100px", height: "100px", objectFit: "cover" }}
          alt="Profile"
        />

      <div className="inter-font mb-3 mt-3 mt-md-5">
        <div
          className="d-flex flex-wrap justify-content-center justify-content-md-start"
          style={{ gap: "25px" }}
        >
          {[
            { id: "about", label: t("new_text_27") },
            { id: "jobs", label: t("t_my_Profile_tab2_text4") }, 
            { id: "photos", label: t("t_my_Profile_tab4_text") }, 
            { id: "videos", label: t("t_my_Profile_tab5_text") }, 
          ].map((tab) => (
            <div
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`inter-font d-flex flex-column align-items-center align-items-md-start ${
                activeTab === tab.id ? "text-dark" : "text-muted"
              }`}
              style={{ cursor: "pointer", minWidth: "70px" }}
            >
              <div className="d-flex align-items-center gap-1">
                <span>{tab.label}</span>
                {isTabIncomplete(tab.id) && (
                  <span
                    style={{
                      width: "8px",
                      height: "8px",
                      borderRadius: "50%",
                      backgroundColor: "red",
                    }}
                  />
                )}
              </div>

              {activeTab === tab.id && (
                <div
                  style={{
                    marginTop: "4px",
                    width: "25px",
                    height: "3px",
                    backgroundColor: "#CD496D",
                    borderRadius: "4px",
                  }}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>

    {/* Right: Content */}
    <div className="inter-font col-12 col-md-10">
      <div className="inter-font d-flex flex-column flex-md-row align-items-start align-items-md-end justify-content-between">
<div style={{ textAlign: isRTL ? "right" : "left" }}>
  <h3 className="inter-font fw-bold">
    {profileData?.talent?.first_name} {profileData?.talent?.last_name}
  </h3>
  <p 
    className="inter-font" 
    style={{ 
      color: "gray",
      direction: "ltr", // Force LTR for location data
      textAlign: isRTL ? "right" : "left" // Keep alignment with header
    }}
  >
    <FaLocationDot className="me-1 text-dark" />
    {[
      profileData?.talent?.nationality,
      profileData?.talent?.country,
    ]
      .filter(Boolean)
      .join(", ")}
    <img
      src={profileData?.talent?.country_flag}
      className="ms-2 rounded-1"
      style={{ width: "35px", height: "25px", objectFit: "cover" }}
      alt="Flag"
    />
  </p>
</div>

        {activeTab === "about" && (
          <button
            className="inter-font btn text-white mt-3 mt-md-0"
            style={{
              background: "#522A30",
              borderRadius: "15px",
              height: "44px",
              width: "auto",
              fontSize: "12px",
            }}
            onClick={handleEditClick}
          >
            <HiPencil /> {t("c_profile_btn")}
          </button>
        )}
      </div>

      {isLoading ? (
        <div className="inter-font d-flex justify-content-center py-5">
          <div className="spinner-border" role="status"></div>
        </div>
      ) : (
        <div className="inter-font tab-content mt-4">
          {activeTab === "about" && profileData?.talent && (
            <AboutTab profileData={profileData?.talent} />
          )}
          {activeTab === "jobs" && <MyJob />}
          {activeTab === "photos" && <Photos />}
          {activeTab === "videos" && <Videos />}
        </div>
      )}
    </div>
  </div>
</div>

      )}
    </div>
  );
};

export default Profile;
